module.exports = __webpack_public_path__ + "img/five01.ac018fc7.png";